namespace Matrix.Data {
    export class JpmSecClassResultColumns {
        static columnsKey = 'Data.JpmSecClassResult';
    }
}
